module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-page"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props) ? _c('div', {
    staticClass: "inner-page-wrap"
  }, [_c('Header'), (_vm.props.better_featured_image) ? _c('div', {
    staticClass: "banner_section",
    style: ({
      backgroundImage: 'url(' + _vm.props.better_featured_image.source_url + ')'
    })
  }, [_c('div', {
    staticClass: "banner_overlay"
  }), (_vm.props.title.rendered) ? _c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.title.rendered)
    }
  }) : _vm._e()]) : _vm._e(), _c('div', {
    staticClass: "gallery_section"
  }, [_c('div', {
    staticClass: "anchor-link",
    attrs: {
      "id": "smile-gallery"
    }
  }), _c('div', {
    staticClass: "manual_container"
  }, [(_vm.props.acf.smile_gallery_title) ? _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.smile_gallery_title)
    }
  }) : _vm._e(), (_vm.props.acf.smile_gallery_list) ? _c('div', {
    staticClass: "smilegallery_wrap clearfix"
  }, _vm._l((_vm.props.acf.smile_gallery_list), function(SmilegalleryList) {
    return _c('div', {
      staticClass: "smilegallery_list"
    }, [_c('img', {
      staticClass: "default",
      attrs: {
        "src": SmilegalleryList.default_img,
        "alt": ""
      }
    }), _c('img', {
      staticClass: "hover",
      attrs: {
        "src": SmilegalleryList.hover_img,
        "alt": ""
      }
    })])
  }), 0) : _vm._e()])]), _c('div', {
    staticClass: "newpatient_section_outer"
  }, _vm._l((_vm.props.acf.care_list), function(CareList, index) {
    return (_vm.props.acf.care_list) ? _c('div', {
      staticClass: "newpatient_section"
    }, [_c('div', {
      staticClass: "anchor-link",
      attrs: {
        "id": "care" + index
      }
    }), _c('div', {
      staticClass: "manual_container"
    }, [_c('div', {
      staticClass: "newpatientwrap clearfix"
    }, [_c('div', {
      staticClass: "newpatient_col",
      domProps: {
        "innerHTML": _vm._s(CareList.content)
      }
    })])]), (CareList.bg_img) ? _c('div', {
      staticClass: "custom_newpatient_img",
      style: ({
        backgroundImage: 'url(' + CareList.bg_img + ')'
      })
    }) : _vm._e()]) : _vm._e()
  }), 0), _c('div', {
    staticClass: "video_section"
  }, [_c('div', {
    staticClass: "anchor-link",
    attrs: {
      "id": "patient-video"
    }
  }), _c('div', {
    staticClass: "manual_container"
  }, [(_vm.props.acf.video_list_title) ? _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.video_list_title)
    }
  }) : _vm._e(), (_vm.props.acf.video_list) ? _c('div', {
    staticClass: "videolist_wrap clearfix"
  }, _vm._l((_vm.props.acf.video_list), function(VideoList) {
    return _c('div', {
      staticClass: "videolist"
    }, [_c('iframe', {
      attrs: {
        "width": "100%",
        "height": "331",
        "src": VideoList.src_url,
        "frameborder": "0",
        "allow": "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
        "allowfullscreen": ""
      }
    })])
  }), 0) : _vm._e()])]), _c('Footer')], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-504b9126","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/our-patient-is-you/our-patient-is-you.pug
// module id = 516
// module chunks = 1